import React from "react";
import { Link } from "react-router-dom";


export default function CreateVehicleIncident() {
    return (
        <div className="createvehicleincident-container my-4">
            <div className="col-md-12">
                <div className="special-header panel-white-all">
                    <h4 className="page-title">Create Vehicle Incident</h4>
                </div>

                <form>
                    <div className="row create-vehicle-incident">
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
                            <select id="vehicleno" className="form-control createfuel-form-select" >
                                <option>Select</option>
                                <option>New Vehicle</option>
                                <option>MH02WE0002</option>
                                <option>Test Vehicle</option>
                            </select>
                        </div>
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="driver" className="form-label"> Driver <span className="text-danger">*</span></label>
                            <select id="driver" className="form-control createfuel-form-select" >
                                <option>Select</option>
                                <option>New Driver</option>
                                <option>Tom</option>
                                <option>Jerry</option>
                            </select>
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="location" className="form-label"> Location <span className="text-danger">*</span>  </label>
                            <input type="text" id="location" className="form-control createfuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="description" className="form-label"> Description<span className="text-danger">*</span> </label>
                            <input type="text" id="description" className="form-control createfuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="expenses" className="form-label"> Expense <span className="text-danger">*</span></label>
                            <input type="text" id="expenses" className="form-control createfuel-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="fordate" className="form-label"> Date <span className="text-danger">*</span></label>
                            <input type="date" id="fordate" className="form-control createfuel-form-control" />
                        </div>

                        <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                            <Link to="/" type="submit" className="btn custom-btn"> Create </Link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
